/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-04-29 21:35:04
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-03 19:44:07
 * @Description: 
 */
import yqAnalytics2 from 'yq-analytics'
window.yqAnalytics = yqAnalytics2;
import * as biz2 from './biz.js'
window.biz = biz2;
require("../css/t1.css");
require("../css/common.css");
require("../ua-device/ua-format.js");
require("../ua-device/apple-device.js");
require("./comreq.js");
require("./t1.js");
require("./util.js");
require("./vue_share_guide3.js");
// require("./vue_usercard3.js?v=2");
// require("./vue_usercard4.js?v=2");
// require("./vue_usercard_new.js");
require("./vue_usercard_light.js");
require("./vue_usercard_edit.js");
require("./vue_footer.js");
require("./vue_share_new.js");
require("./vue_loading.js");
require("./vue_encourage_box.js");
require("./vue_showPoster.js");
require("./vue_loading.js");
require("./vue_showimg.js");
require("./vue_main.js");
